export default __webpack_public_path__ + "static/media/error_graphic.3f616789.svg";